export const ReportAssignmentStatus = {
  AWAITING: "Awaiting",
  IN_PROGRESS: "In Progress",
  DRAFT: "Draft",
  READY_FOR_REVIEW: "Ready for Review",
  ACCEPTED: "Accepted",
  REJECTED: "Rejected",
  SUBMISSION_NOT_REQUIRED: "Submission Not Required",
  SUBMITTED_TO_BOE: "Submitted to BOE/NYEIS",
  CANCELLED: "Cancelled",
};